<template>
  <div class="row mb-5 px-0 b-form__row_type_flex-end b-contracts__lessor-item-inner">
    <div class="col-5">
      <LessorItem :lessor="currentLessor"
                  :lessorIndex="lessorIndex"
                  @selectLessor="onSelectLessor"
                  :ref="`lessor-${lessorIndex}`"
                  :isError="isError"
                  :isDisabled="selectDisabled"
                  :hiddenLessorIds="hiddenLessorIds"/>
    </div>
    <div class="pr-1">
      <button
        type="button"
        :data-cy="`add-lessor-${lessorIndex}`"
        class="b-btn b-btn_type_add"
        @click="openCounterPartyForLessorDialog">
        <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="plus"/>
      </button>
    </div>
    <button
      type="button"
      :data-cy="`import-lessor-${lessorIndex}`"
      class="b-btn b-btn_type_add"
      @click="openImportDialog"
    >
      <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="xls"></dynamic-icon>
    </button>
    <div class="b-contract__check mx-2 mb-2" v-if="checkIsCounterpartyIntragroup">
      <dynamic-icon class="mr-2" icon="check"></dynamic-icon>
      {{$t('CONTENT.counterparty.VGO')}}
    </div>
    <button type="button" class="b-btn b-btn_border_none" @click="deleteLessorItem" v-if="!deleteDisabled">
      <dynamic-icon class="b-btn__icon" icon="close"></dynamic-icon>
    </button>
    <popup :name="`lessor-counterparty-popup-${lessorIndex}`" height="auto" :scrollable="true">
      <server-error :error="error"/>
      <GeneralForm
        v-if="isCounterPartyForLessorShow"
        :counterparty="counterpartyForForm"
        :counterpartyVatHistoryList="counterpartyVatHistoryList"
        @createNewCounterparty="onCreateCounterpartyForLessor()"
        @openVatSettings="openVatSettings"
        @close="closeCounterPartyForLessorDialog()"
      />
    </popup>
    <popup :name="`vat-settings-popup-${lessorIndex}`" height="auto" :scrollable="true">
      <VatSettingsForm
        v-if="isVatSettingsOpen"
        :rates="counterpartyVatHistoryList"
        :counterparty-type-id="counterpartyForForm ? counterpartyForForm.idInDB : null"
        :is-create="!counterpartyForForm || !counterpartyForForm.idInDB"
        @close="closeVatSettings"
        @saveVatRates="updateVatRates"
      />
    </popup>
  </div>
</template>

<script>
import LessorItem from "./LessorItem";
import GeneralForm from "../../../directories/counterparty/edit/GeneralForm";
import VatSettingsForm from "../../../directories/counterparty/edit/VatSettingsForm";
import {mapGetters} from 'vuex';

export default {
  components: {
    LessorItem,
    GeneralForm,
    VatSettingsForm,
  },
  props: {
    lessor: {
      type: Number | String,
    },
    lessorIndex: {
      type: Number,
    },
    deleteDisabled: {
      type: Boolean,
    },
    selectDisabled: {
      type: Boolean,
    },
    isError: {
      type: Boolean
    },
    hiddenLessorIds: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      isDisabledAddLessor: true,
      isShowImportDialog: false,
      currentLessor: null,
      isCounterPartyForLessorShow: false,
      counterpartyForForm: null,
      isVatSettingsOpen: false,
      counterpartyVatHistoryList: [],
      error: null,
    }
  },
  created() {
    this.currentLessor = this.lessor;
  },
  watch: {
    lessor(newVal) {
      this.currentLessor = newVal;
    }
  },
  computed: {
    ...mapGetters(['allCounterparties']),
    ...mapGetters(["getCounterpartiresForContract"]),
    checkIsCounterpartyIntragroup: {
      get() {
        if(this.currentLessor === null) {
          return false;
        } else {
          return this.checkIsCounterpartyIntragroupFn(this.currentLessor);
        }
      },
      set(newVal) {
        this.currentLessor = +newVal;
      }
    }
  },
  methods: {
    openImportDialog() {
      this.$emit('openImportDialog');
    },
    deleteLessorItem() {
      this.$store.commit('DELETE_LESSOR', {index: this.lessorIndex});
      this.currentLessor = this.lessor;
    },
    checkIsCounterpartyIntragroupFn(id) {
      for (let i = 0; i < this.allCounterparties.length; i++) {
        if (this.allCounterparties[i].idInDB === id) {
          return this.allCounterparties[i].isIntragroupTurnover;
        }
      }
    },
    onSelectLessor(item) {
      this.$emit('selectLessor', this.lessorIndex, item);
      this.currentLessor = item;
    },
    closeCounterPartyForLessorDialog() {
      this.isCounterPartyForLessorShow = false;
      this.counterpartyForForm = null;
      this.$modal.hide(`lessor-counterparty-popup-${this.lessorIndex}`);
    },
    openCounterPartyForLessorDialog() {
      this.counterpartyVatHistoryList = [];
      this.isCounterPartyForLessorShow = true;
      this.$modal.show(`lessor-counterparty-popup-${this.lessorIndex}`);
    },
    openVatSettings() {
      this.isVatSettingsOpen = true;
      this.$modal.show(`vat-settings-popup-${this.lessorIndex}`);
    },
    closeVatSettings() {
      this.isVatSettingsOpen = false;
      this.$modal.hide(`vat-settings-popup-${this.lessorIndex}`);
    },
    updateVatRates(rates) {
      this.counterpartyVatHistoryList = rates;
    },
    async onCreateCounterpartyForLessor() {
      this.setNewCounterpartyForLessor(this.lessorIndex);
    },
    async setNewCounterpartyForLessor(index) {
      await this.$store.dispatch('getAllCounterparties');
      this.$store.commit('UPDATE_LESSOR', {value: this.getCounterpartiresForContract[0].id, index: index});
      this.$refs[`lessor-${index}`].currentLessorId = this.getCounterpartiresForContract[0].id;
      this.$emit('setNewLessor', index);
      this.$emit('selectLessor');
    },
  }
}
</script>
